export const FORMBRICKS_SURVEYS_FILTERS_KEY_LS = "formbricks-surveys-filters";
export const FORMBRICKS_ENVIRONMENT_ID_LS = "formbricks-environment-id";
export const FORMBRICKS_WORKSPACE_ID_LS = "formbricks-workspace-id";
export const FORMBRICKS_LOGGED_IN_WITH_LS = "formbricks-logged-in-with";
